/* unplugin-vue-components disabled */
import {Users} from 'stores/users.js'
import {DataTable, Column} from 'components/data-table'
import AssignModal from './assign-modal.vue'
import InviteModal from './invite-modal.vue'
import EditModal from './edit-user-modal.vue'
import ResetPasswordModal from './reset-password-modal.vue'
import Rest from 'utils/rest'
import {API2_USERS} from 'consts/api2'
import $profile from 'stores/profile'
import $global from 'stores/global'

export default {
  components: {DataTable, Column, AssignModal, InviteModal, EditModal, ResetPasswordModal},
  props: {
    tenant: {type: Object, required: true}
  },
  data() {
    return {
      store: new Users(),
      loading: true,
      load_params: this.defParams()
    }
  },
  computed: {
    refreshing() {
      return this.store.loading
    },
    view_items() {
      return this.store.view_items
    },
    view_total() {
      return this.store.view_total
    },
  },
  async mounted() {
    this.loading = true
    await this.store.load(this.load_params)
    this.loading = false
  },
  methods: {
    can_disable(id) {
      return $profile.id != id
    },
    defParams() {
      return {skip: 0, limit: 20, tenant_id: this.tenant.id}
    },
    async onSearch(filter) {
      const load_params = {...this.defParams(), filter}
      await this.store.load(load_params)
      this.load_params = load_params
    },
    async onPage(ev) {
      this.load_params = {...this.load_params, skip: ev.first, limit: ev.rows}
      await this.store.load(this.load_params)
    },
    async onRemoveUser(user_id) {
      const user = await this.store.loadUser(user_id)
      user.tenant_id = null
      await user.save()
      await this.store.load(this.load_params)
    },
    isExternal(email) {
      const domain = email.split('@')[1].toLowerCase()
      const realmProviders = JSON.parse(PROVIDERS)
      return !!realmProviders.domain_providers[domain]
    },
    onResetPasswordDialog(user) {
      this.$refs.resetPasswordModal.open(user)
    },
    async onResetPassword(user_id, {use_aws_email}) {
      try {
        const rest = new Rest()
        await rest.post(`${API2_USERS}/${user_id}/reset-password`, {use_aws_email})
        $utils.toasts.success('Password reset email sent', 5000)
      }
      catch (err) {
        $utils.toasts.error(`Failed to reset password: ${err}`)
      }
    },
    async onDownloadFollowed(user_id) {
      const rest = new Rest({json: false})
      let csv
      try {
        csv = await rest.get(`${API2_USERS}/${user_id}/download-followed`)
      }
      catch(err) {
        $utils.toasts.error('User has no followed entities')
        return
      }
      $utils.stringToFile(csv, `followed-entities-${user_id}.csv`, 'text/csv')

    },
    onAssignDialog() {
      this.$refs.assignModal.open()
    },
    async onAssignUser(user_id, {is_superuser, is_beta, is_tenant_manager}) {
      const user = await this.store.loadUser(user_id)
      user.is_superuser = is_superuser
      user.is_beta = is_beta
      user.is_tenant_manager = is_tenant_manager
      user.tenant_id = this.tenant.id
      await user.save()
      await this.store.load(this.load_params)
      $utils.toasts.success(`User ${user.first_name} ${user.last_name} has been successfully assigned to ${this.tenant.name}`)

      if (user_id == $profile.id) {
        window.location.reload()
      }
    },
    onInviteDialog() {
      this.$refs.inviteModal.open()
    },
    async onInviteUser(data) {
      try {
        await this.store.inviteUser({...data, tenant_id: this.tenant.id})
        $utils.toasts.success(`User ${data.first_name} ${data.last_name} has been invited to ${this.tenant.name}`)
        await this.store.load(this.load_params)
      }
      catch(err) {
        $utils.toasts.error(`Failed to invite user: ${err}`)
      }
    },
    async onDisableEnable(id, disabled) {
      const user = this.store.getUser(id)
      user.disabled = disabled
      user.save()
      $utils.toasts.success('User has been successfully updated')
    },
    onEditDialog(id) {
      const user = this.store.getUser(id)
      this.$refs.editModal.open(user)
    },
    async onEditUser(user_id, {first_name, last_name, title, bio, offering, is_superuser, is_beta, is_tenant_manager}) {
      const user = this.store.getUser(user_id)

      user.is_superuser = is_superuser
      user.is_beta = is_beta
      user.is_tenant_manager = is_tenant_manager
      user.first_name = first_name
      user.last_name = last_name
      user.title = title
      user.bio = bio
      user.offering = offering

      await user.save()
      $utils.toasts.success(`User ${user.display_name} successfully updated.`)

      if (user_id == $profile.id) {
        window.location.reload()
      }
    },
    onGoToTenantUser(tenant_id, user_id) {
      $global.goToTenantUser(tenant_id, user_id)
    },
  }
}
